import { cloneDeep } from 'lodash';

export class ViewerState {
  constructor ($vil) {
    this.$vil = $vil;
  }

  maybeSaveDst () {
    this.$vil.saveDSTifModified();
  }

  save () {
    this.$vil.uScopeSaveAndClose();
    // save the VIL settings in the container div
    this.$vil.data('vilSettings', cloneDeep(this.$vil.getSettings()));
    // save the DST state to the database
    this.$vil.saveDst();
  }

  restore () {
    $.setVilInstance(this.$vil);
    const settings = this.$vil.data('vilSettings');

    if (settings) {
      this.$vil.removeData('vilSettings');
      this.$vil.putSettings(settings);
      this.$vil.uScopeRestore();
    }
  }

  teardown () {
    this.$vil.remove();
  }
}



// WEBPACK FOOTER //
// ./src/viewer/core/instance/ViewerState.js